import { Search, Bookmark, Star } from 'lucide-react'

const VENDORS = [
  { name: 'Lumen Studios', type: 'Photographer', city: 'New York, NY', saved: true },
  { name: 'Fleur de Soleil', type: 'Florist', city: 'Brooklyn, NY', saved: false },
  { name: 'Apex Catering Co.', type: 'Caterer', city: 'Manhattan, NY', saved: true },
  { name: 'The Plaza Hotel', type: 'Venue', city: 'New York, NY', saved: false },
]

// Static decorative mock of the event services directory. Not interactive.
export default function VendorListPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="border-b border-black/5 p-4">
        <div className="flex items-center gap-2 rounded-lg bg-muted/50 px-3 py-2">
          <Search className="size-4 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Search vendors</span>
        </div>
      </div>
      <ul className="divide-y divide-black/5">
        {VENDORS.map((v) => (
          <li key={v.name} className="flex items-center gap-3 px-4 py-3">
            <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-sm font-semibold text-primary">
              {v.name[0]}
            </span>
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-1.5 text-sm font-medium">
                {v.name}
                <Star className="size-3 fill-secondary text-secondary" />
              </p>
              <p className="text-xs text-muted-foreground">{v.type} · {v.city}</p>
            </div>
            <Bookmark className={`size-4 shrink-0 ${v.saved ? 'fill-primary text-primary' : 'text-muted-foreground'}`} />
          </li>
        ))}
      </ul>
    </div>
  )
}
